module.exports = __webpack_public_path__ + "img/logo_dfg.36d3b96c.svg";